import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NucToastService } from '@relayter/rubber-duck';
import { Toaster } from './classes/toaster.class';

@Component({
    selector: 'om-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    private readonly toastService = inject(NucToastService);

    public ngOnInit() {
        Toaster.initialize(this.toastService);
    }
}
